/** Klartext → sicheres HTML-Fragment (Absätze, Zeilenumbrüche). */
export function plainTextToMailHtmlFragment(text: string | null | undefined): string {
  const raw = String(text || "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n");
  if (!raw.trim()) return '<p style="margin:0;"></p>';
  const blocks = raw.split("\n\n");
  const chunks: string[] = [];
  for (const block of blocks) {
    const lines = block.split("\n");
    const inner = lines
      .map((line) =>
        line
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;"),
      )
      .join("<br>\n");
    chunks.push(`<p style="margin:0 0 0.85em 0;">${inner}</p>`);
  }
  return chunks.join("\n");
}

/** HTML → Klartext (für text/plain-Alternative). */
export function htmlToPlainText(html: string | null | undefined): string {
  if (!html?.trim()) return "";
  const el = document.createElement("div");
  el.innerHTML = html;
  return (el.textContent || "")
    .split("\n")
    .map((line) => line.trimEnd())
    .join("\n")
    .trim();
}

export function wrapMailHtmlDocument(innerHtml: string): string {
  return `<!DOCTYPE html><html lang="de"><head><meta charset="utf-8"></head><body><div class="eh-mail-html-root" style="font-family:Calibri,Arial,sans-serif;font-size:11pt;color:#222;">${innerHtml}</div></body></html>`;
}

/** Multipart/alternative .eml für HTML-Mails im lokalen Mailprogramm. */
export function downloadHtmlEml(to: string, subject: string, htmlBody: string, plainBody?: string): void {
  const plain = (plainBody || htmlToPlainText(htmlBody)).replace(/\n/g, "\r\n");
  const html = wrapMailHtmlDocument(htmlBody);
  const boundary = `----=_Ernsthaus_${Date.now()}`;
  const content = [
    `To: ${to || ""}`,
    `Subject: ${subject || ""}`,
    "MIME-Version: 1.0",
    `Content-Type: multipart/alternative; boundary="${boundary}"`,
    "",
    `--${boundary}`,
    "Content-Type: text/plain; charset=UTF-8",
    "Content-Transfer-Encoding: 8bit",
    "",
    plain,
    `--${boundary}`,
    "Content-Type: text/html; charset=UTF-8",
    "Content-Transfer-Encoding: 8bit",
    "",
    html,
    `--${boundary}--`,
  ].join("\r\n");
  const blob = new Blob([content], { type: "message/rfc822;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "bestellung.eml";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
